import { Sentry } from '../../entry-setup/sentry';

// The bell count is live — chat reads hand back an authoritative count, and
// incoming chat messages report their own once the row behind them is written
// — but the dropdown body underneath it is HTML the header rendered once, at
// page load. Refetch that body whenever something has moved the count, so the
// rows the user opens match the number they clicked.
export function notificationsMenu({ menuUrl, unreadCount = 0, labels = {} } = {}) {
  return {
    open: false,
    t: labels,
    unreadCount,
    bodyStale: false,
    refreshing: false,

    async toggle() {
      this.open = !this.open;
      if (this.open && this.bodyStale) await this.refreshBody();
    },

    async refreshBody() {
      if (this.refreshing) return;
      this.refreshing = true;

      try {
        const { data } = await this.$api({ url: menuUrl, method: 'GET' });
        this.$refs.body.innerHTML = data.html;
        // The activity behind an incoming chat message is written by a queued
        // job, so a refresh can land before the row exists. Take the count that
        // describes the list actually rendered, and stay stale when it differs
        // from what we were showing so the next open picks up the rest.
        this.bodyStale = data.unread_notification_count !== this.unreadCount;
        this.unreadCount = data.unread_notification_count;
      } catch (err) {
        // The stale list stays on screen, so the user sees rows that trail the
        // badge rather than an empty menu. Nothing to show them; report it.
        Sentry.captureException(err, {
          extra: {
            message: 'Failed to refresh the notifications menu',
            unreadCount: this.unreadCount
          }
        });
      } finally {
        this.refreshing = false;
      }
    },
  };
}
